module.exports = __webpack_public_path__ + "media/images/fm_6-ad13b6142be2c88cc698b71420be9076.png";